import { lazy } from 'react';
export const InvoicesPageLazy = lazy(() => import('./InvoicesPage'));
